var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6281 10.2117L8.78566 7.79418C8.49183 7.52974 8.17758 7.40833 7.92373 7.42005C8.5947 6.63409 9 5.61444 9 4.50001C9 2.01472 6.98529 0 4.5 0C2.01471 0 0 2.01472 0 4.50001C0 6.98531 2.01471 9.00002 4.5 9.00002C5.61443 9.00002 6.63408 8.59472 7.42003 7.92372C7.40831 8.17757 7.52972 8.49182 7.79416 8.78566L10.2117 11.6281C10.6256 12.088 11.3018 12.1268 11.7143 11.7143C12.1267 11.3018 12.088 10.6256 11.6281 10.2117ZM4.5 7.50002C2.84316 7.50002 1.5 6.15686 1.5 4.50001C1.5 2.84316 2.84316 1.5 4.5 1.5C6.15684 1.5 7.5 2.84316 7.5 4.50001C7.5 6.15686 6.15687 7.50002 4.5 7.50002Z",
    fill: "#454545"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/search_icon.1f76aecbb3e0afd68d40b9bf89e062a6.svg";
export { ForwardRef as ReactComponent };